
import Vue from 'vue';
import MultipleSelectInputField from '@components/new-styleguide/form/MultipleSelectInputField.vue';
import { Component, Prop } from 'vue-property-decorator';
import { formatVehicle } from '@/utils/vehicleFormat';
import { MultipleSelectValue } from '@components/new-styleguide/form/MultipleSelectInputField.vue';
import { TripLog } from '@clients/myTrips';

@Component({
  name: 'MultipleVehicleSelect',
  components: {
    MultipleSelectInputField
  }
})
export default class MultipleVehicleSelect extends Vue {
  @Prop()
  private value: Array<TripLog>;

  @Prop()
  private vehicles: TripLog[];

  @Prop({ default: false })
  private disabled: boolean;

  get mappedValue() {
    return this.value.map(t => ({
      id: t.vehicle.id,
      name: formatVehicle(t.vehicle)
    }))
  }
  get vehicleOptions(): MultipleSelectValue[] {
    return this.vehicles.map(car => ({
      name: formatVehicle(car.vehicle),
      id: car.vehicle.id
    }));
  }

  private handleInput(input: MultipleSelectValue[]) {
    this.$emit('input', Array.from(input.map(select => this.vehicles.find(v => v.vehicle.id === select.id))));
  }
}
